import styled from "styled-components";
import { TextField as MuiTextField } from "@material-ui/core";

export const TextField = styled(MuiTextField)`
    width: 25rem;
    margin: 10px 0;
`;

export default TextField;
